/* eslint-disable */

export interface HttpClient<Headers> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Headers; }): RestResponse<R>;
}

export class RestApplicationClient<Headers> {

    constructor(protected httpClient: HttpClient<Headers>) {
    }

    /**
     * HTTP GET /application.wadl
     * Java method: org.glassfish.jersey.server.wadl.internal.WadlResource.getWadl
     */
    getWadl(options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`application.wadl`, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP GET /application.wadl/{path}
     * Java method: org.glassfish.jersey.server.wadl.internal.WadlResource.getExternalGrammar
     */
    getExternalGrammar(path: string, options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`application.wadl/${path}`, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP GET /bank
     * Java method: no.eika.kreditt.boliglaansoeknad.web.bank.BankResource.getBankkonfigurasjon
     */
    getBankkonfigurasjon(options?: Headers): RestResponse<BankWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`bank`, copyFn: __identity<BankWeb>(), options: options });
    }

    /**
     * HTTP GET /bank/hjemmeside
     * Java method: no.eika.kreditt.boliglaansoeknad.web.bank.BankResource.getHjemmeside
     */
    getHjemmeside(options?: Headers): RestResponse<HjemmesideWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`bank/hjemmeside`, copyFn: __identity<HjemmesideWeb>(), options: options });
    }

    /**
     * HTTP PUT /barn/updateBarn
     * Java method: no.eika.kreditt.boliglaansoeknad.web.barn.BarnResource.updateBarn
     */
    updateBarn(arg0: BarnContainerWeb, options?: Headers): RestResponse<BarnContainerWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`barn/updateBarn`, data: arg0, copyFn: __identity<BarnContainerWeb>(), options: options });
    }

    /**
     * HTTP DELETE /barn/{soeknadId}/{barnId}/deleteBarn
     * Java method: no.eika.kreditt.boliglaansoeknad.web.barn.BarnResource.deleteBarn
     */
    deleteBarn(soeknadId: string, barnId: string, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`barn/${soeknadId}/${barnId}/deleteBarn`, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /barn/{soeknadType}/barn
     * Java method: no.eika.kreditt.boliglaansoeknad.web.barn.BarnResource.getBarn
     */
    getBarn(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<BarnContainerWeb | null> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`barn/${soeknadType}/barn`, copyFn: __identity<BarnContainerWeb | null>(), options: options });
    }

    /**
     * HTTP PUT /bil/updateBil
     * Java method: no.eika.kreditt.boliglaansoeknad.web.bil.BilResource.updateBiler
     */
    updateBiler(arg0: BilUpdateWeb, options?: Headers): RestResponse<BilWeb[]> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`bil/updateBil`, data: arg0, copyFn: __getCopyArrayFn(__identity<BilWeb>()), options: options });
    }

    /**
     * HTTP DELETE /bil/{soeknadId}/{bilId}/deleteBil
     * Java method: no.eika.kreditt.boliglaansoeknad.web.bil.BilResource.deleteBil
     */
    deleteBil(soeknadId: string, bilId: string, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`bil/${soeknadId}/${bilId}/deleteBil`, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /bil/{soeknadType}/biler
     * Java method: no.eika.kreditt.boliglaansoeknad.web.bil.BilResource.getBiler
     */
    getBiler(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<BilContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`bil/${soeknadType}/biler`, copyFn: __identity<BilContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /bil/{soeknadType}/kjoeretoey
     * Java method: no.eika.kreditt.boliglaansoeknad.web.bil.BilResource.getKjoeretoeyAsync
     */
    getKjoeretoeyAsync(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<BilContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`bil/${soeknadType}/kjoeretoey`, copyFn: __identity<BilContainerWeb>(), options: options });
    }

    /**
     * HTTP PUT /egenkapital/saveEgenkapital
     * Java method: no.eika.kreditt.boliglaansoeknad.web.egenkapital.EgenkapitalResource.saveEgenkapital
     */
    saveEgenkapital(arg0: EgenkapitalWeb, options?: Headers): RestResponse<EgenkapitalWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`egenkapital/saveEgenkapital`, data: arg0, copyFn: __identity<EgenkapitalWeb>(), options: options });
    }

    /**
     * HTTP GET /egenkapital/{soeknadType}/egenkapital
     * Java method: no.eika.kreditt.boliglaansoeknad.web.egenkapital.EgenkapitalResource.getEgenkapital
     */
    getEgenkapital(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<EgenkapitalWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`egenkapital/${soeknadType}/egenkapital`, copyFn: __identity<EgenkapitalWeb>(), options: options });
    }

    /**
     * HTTP GET /eiendom
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getEiendomsregister
     */
    getEiendomsregister(options?: Headers): RestResponse<EiendomWeb[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom`, copyFn: __getCopyArrayFn(__identity<EiendomWeb>()), options: options });
    }

    /**
     * HTTP GET /eiendom/adresser
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getAdresser
     */
    getAdresser(queryParams?: { query?: string; }, options?: Headers): RestResponse<AdresseSoekWeb[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/adresser`, queryParams: queryParams, copyFn: __getCopyArrayFn(__identity<AdresseSoekWeb>()), options: options });
    }

    /**
     * HTTP GET /eiendom/etakst/{referansenummer}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getETakst
     */
    getETakst(referansenummer: string, options?: Headers): RestResponse<EtakstWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/etakst/${referansenummer}`, copyFn: __identity<EtakstWeb>(), options: options });
    }

    /**
     * HTTP GET /eiendom/poststed/{postnummer}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getPoststed
     */
    getPoststed(postnummer: string, options?: Headers): RestResponse<PoststedWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/poststed/${postnummer}`, copyFn: __identity<PoststedWeb>(), options: options });
    }

    /**
     * HTTP PUT /eiendom/updateEiendomsverdi
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.updateEiendomsverdi
     */
    updateEiendomsverdi(arg0: EiendomsverdiUpdateWeb, options?: Headers): RestResponse<EiendomsverdiUpdateWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`eiendom/updateEiendomsverdi`, data: arg0, copyFn: __identity<EiendomsverdiUpdateWeb>(), options: options });
    }

    /**
     * HTTP POST /eiendom/verdivurdering
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.requestVerdivurdering
     */
    requestVerdivurdering(arg0: VerdivurderingInfoWeb, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`eiendom/verdivurdering`, data: arg0, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /eiendom/{adresseKey}/info
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getAdresseInfo
     */
    getAdresseInfo(adresseKey: string, options?: Headers): RestResponse<AdresseInfoWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/${adresseKey}/info`, copyFn: __identity<AdresseInfoWeb>(), options: options });
    }

    /**
     * HTTP GET /eiendom/{organisasjonsnummer}/{andelsnummer}/fellesgjeld
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getFellesgjeld
     */
    getFellesgjeld(organisasjonsnummer: string, andelsnummer: string, options?: Headers): RestResponse<number> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/${organisasjonsnummer}/${andelsnummer}/fellesgjeld`, copyFn: __identity<number>(), options: options });
    }

    /**
     * HTTP POST /eiendom/{soeknadId}/eiendomsverdi
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.findEiendomsverdiMatrikkel
     */
    findEiendomsverdiMatrikkel(soeknadId: string, arg1: EiendomsverdiParamWeb, options?: Headers): RestResponse<EiendomsverdiWeb> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`eiendom/${soeknadId}/eiendomsverdi`, data: arg1, copyFn: __identity<EiendomsverdiWeb>(), options: options });
    }

    /**
     * HTTP GET /eiendom/{soeknadId}/eiendomsverdi/{organisasjonsnummer}/{andelsnummer}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getEiendomsverdi
     */
    getEiendomsverdi$GET$eiendom_soeknadId_eiendomsverdi_organisasjonsnummer_andelsnummer(soeknadId: string, organisasjonsnummer: string, andelsnummer: string, options?: Headers): RestResponse<EiendomsverdiWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/${soeknadId}/eiendomsverdi/${organisasjonsnummer}/${andelsnummer}`, copyFn: __identity<EiendomsverdiWeb>(), options: options });
    }

    /**
     * HTTP DELETE /eiendom/{soeknadId}/{eiendomUUID}/deleteEiendom
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.deleteEiendom
     */
    deleteEiendom(soeknadId: string, eiendomUUID: string, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`eiendom/${soeknadId}/${eiendomUUID}/deleteEiendom`, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /eiendom/{soeknadType}/{eiendomType}/eiendomsverdi
     * Java method: no.eika.kreditt.boliglaansoeknad.web.eiendom.EiendomResource.getEiendomsverdi
     */
    getEiendomsverdi$GET$eiendom_soeknadType_eiendomType_eiendomsverdi(soeknadType: SoeknadstypeWeb, eiendomType: EiendomTypeWeb, options?: Headers): RestResponse<EiendomsverdiContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`eiendom/${soeknadType}/${eiendomType}/eiendomsverdi`, copyFn: __identity<EiendomsverdiContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /engasjement/{soeknadId}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.engasjementer.EngasjementResource.getEngasjementer
     */
    getEngasjementer(soeknadId: string, options?: Headers): RestResponse<EngasjementWeb[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`engasjement/${soeknadId}`, copyFn: __getCopyArrayFn(__identity<EngasjementWeb>()), options: options });
    }

    /**
     * HTTP PUT /gjeld/deleteGjeld
     * Java method: no.eika.kreditt.boliglaansoeknad.web.gjeld.GjeldResource.deleteGjeld
     */
    deleteGjeld(arg0: GjeldDeleteWeb, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`gjeld/deleteGjeld`, data: arg0, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP PUT /gjeld/updateGjeld
     * Java method: no.eika.kreditt.boliglaansoeknad.web.gjeld.GjeldResource.updateGjeld
     */
    updateGjeld(arg0: GjeldContainerWeb, options?: Headers): RestResponse<GjeldContainerWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`gjeld/updateGjeld`, data: arg0, copyFn: __identity<GjeldContainerWeb>(), options: options });
    }

    /**
     * HTTP POST /gjeld/{soeknadId}/interngjeld
     * Java method: no.eika.kreditt.boliglaansoeknad.web.gjeld.GjeldResource.saveInternGjeld
     */
    saveInternGjeld(soeknadId: string, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`gjeld/${soeknadId}/interngjeld`, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /gjeld/{soeknadType}/gjeld
     * Java method: no.eika.kreditt.boliglaansoeknad.web.gjeld.GjeldResource.getGjeld
     */
    getGjeld(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<GjeldContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`gjeld/${soeknadType}/gjeld`, copyFn: __identity<GjeldContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /health/started
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.started
     */
    started(options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`health/started`, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP PUT /inntekt/deleteInntekt
     * Java method: no.eika.kreditt.boliglaansoeknad.web.inntekt.InntektResource.deleteInntekt
     */
    deleteInntekt(arg0: InntektDeleteWeb, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`inntekt/deleteInntekt`, data: arg0, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP POST /inntekt/leieinntekter
     * Java method: no.eika.kreditt.boliglaansoeknad.web.inntekt.InntektResource.lagreLeieinntekter
     */
    lagreLeieinntekter(arg0: FormData, options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`inntekt/leieinntekter`, data: arg0, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP PUT /inntekt/updateInntekt
     * Java method: no.eika.kreditt.boliglaansoeknad.web.inntekt.InntektResource.updateInntekt
     */
    updateInntekt(arg0: InntektUpdateWeb, options?: Headers): RestResponse<InntektUpdateWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`inntekt/updateInntekt`, data: arg0, copyFn: __identity<InntektUpdateWeb>(), options: options });
    }

    /**
     * HTTP GET /inntekt/{soeknadType}/inntekt
     * Java method: no.eika.kreditt.boliglaansoeknad.web.inntekt.InntektResource.getInntekt
     */
    getInntekt(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<InntektContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`inntekt/${soeknadType}/inntekt`, copyFn: __identity<InntektContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /inntekt/{soeknadType}/leieinntekter
     * Java method: no.eika.kreditt.boliglaansoeknad.web.inntekt.InntektResource.getLeieinntekter
     */
    getLeieinntekter(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<LeieinntekterWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`inntekt/${soeknadType}/leieinntekter`, copyFn: __identity<LeieinntekterWeb>(), options: options });
    }

    /**
     * HTTP POST /laantaker/dsf/barn/{soeknadId}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getBarnDsf
     */
    getBarnDsf(soeknadId: string, arg1: ForeldreWeb, options?: Headers): RestResponse<BarnWeb[]> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`laantaker/dsf/barn/${soeknadId}`, data: arg1, copyFn: __getCopyArrayFn(__identity<BarnWeb>()), options: options });
    }

    /**
     * HTTP PUT /laantaker/dsf/navn
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getPersonNavn
     */
    getPersonNavn(arg0: NavnWeb, options?: Headers): RestResponse<NavnWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`laantaker/dsf/navn`, data: arg0, copyFn: __identity<NavnWeb>(), options: options });
    }

    /**
     * HTTP GET /laantaker/dsf/{erHovedlaantaker}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getLaantakerDsf
     */
    getLaantakerDsf(erHovedlaantaker: boolean, options?: Headers): RestResponse<LaantakerWeb | null> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laantaker/dsf/${erHovedlaantaker}`, copyFn: __identity<LaantakerWeb | null>(), options: options });
    }

    /**
     * HTTP GET /laantaker/geoomraade
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getGeoOmraade
     */
    getGeoOmraade(options?: Headers): RestResponse<Postnummer[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laantaker/geoomraade`, copyFn: __getCopyArrayFn(__identity<Postnummer>()), options: options });
    }

    /**
     * HTTP GET /laantaker/innlogget
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.isInnlogget
     */
    isInnlogget(options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laantaker/innlogget`, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /laantaker/kerne/{erHovedlaantaker}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getLaantakerKerne
     */
    getLaantakerKerne(erHovedlaantaker: boolean, options?: Headers): RestResponse<LaantakerWeb | null> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laantaker/kerne/${erHovedlaantaker}`, copyFn: __identity<LaantakerWeb | null>(), options: options });
    }

    /**
     * HTTP PUT /laantaker/updateKontaktinformasjon
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.updateKontaktinformasjon
     */
    updateKontaktinformasjon(arg0: KontaktinformasjonWeb, options?: Headers): RestResponse<KontaktinformasjonWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`laantaker/updateKontaktinformasjon`, data: arg0, copyFn: __identity<KontaktinformasjonWeb>(), options: options });
    }

    /**
     * HTTP GET /laantaker/{erHovedlaantaker}/{soeknadsId}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getLantaker
     */
    getLantaker(erHovedlaantaker: boolean, soeknadsId: string, options?: Headers): RestResponse<LaantakerWeb | null> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laantaker/${erHovedlaantaker}/${soeknadsId}`, copyFn: __identity<LaantakerWeb | null>(), options: options });
    }

    /**
     * HTTP PUT /laantaker/{soeknadId}
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.updateLaantaker
     */
    updateLaantaker$PUT$laantaker_soeknadId(soeknadId: string, arg1: LaantakerWeb, options?: Headers): RestResponse<LaantakerWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`laantaker/${soeknadId}`, data: arg1, copyFn: __identity<LaantakerWeb>(), options: options });
    }

    /**
     * HTTP GET /laantaker/{soeknadType}/kontaktinformasjon
     * Java method: no.eika.kreditt.boliglaansoeknad.web.laantaker.LaantakerResource.getKontaktinformasjon
     */
    getKontaktinformasjon(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<KontaktinformasjonWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`laantaker/${soeknadType}/kontaktinformasjon`, copyFn: __identity<KontaktinformasjonWeb>(), options: options });
    }

    /**
     * HTTP GET /liveness/health
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.liveness
     */
    liveness(options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`liveness/health`, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP POST /log/{level}
     * Java method: no.eika.infrastruktur.jakarta.server.lib.FrontendLogResource.log
     */
    log(level: string, arg3: { [index: string]: any }, options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`log/${level}`, data: arg3, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP GET /readiness/status
     * Java method: no.eika.infrastruktur.jakarta.server.lib.HealthResource.readiness
     */
    readiness(options?: Headers): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`readiness/status`, copyFn: __identity<any>(), options: options });
    }

    /**
     * HTTP GET /resource/banker/features
     * Java method: no.eika.kreditt.boliglaansoeknad.web.toggle.FeatureToggleResource.allFeatureToggles
     */
    allFeatureToggles(options?: Headers): RestResponse<{ [index: string]: boolean }> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`resource/banker/features`, copyFn: __getCopyObjectFn(__identity<boolean>()), options: options });
    }

    /**
     * HTTP POST /samtykke/create
     * Java method: no.eika.kreditt.boliglaansoeknad.web.samtykke.SamtykkeResource.getSamtykkeUrl
     */
    getSamtykkeUrl(arg0: SamtykkeRequestWeb, options?: Headers): RestResponse<SamtykkeResponseWeb | null> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`samtykke/create`, data: arg0, copyFn: __identity<SamtykkeResponseWeb | null>(), options: options });
    }

    /**
     * HTTP PUT /soeknad/delete
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.deleteSoeknad
     */
    deleteSoeknad(arg0: DeleteSoeknad, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`soeknad/delete`, data: arg0, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /soeknad/medlaantaker
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.findSoeknadMedlaantaker
     */
    findSoeknadMedlaantaker(options?: Headers): RestResponse<SoeknadContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`soeknad/medlaantaker`, copyFn: __identity<SoeknadContainerWeb>(), options: options });
    }

    /**
     * HTTP PUT /soeknad/saveSoeknad
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.saveSoeknad
     */
    saveSoeknad(arg0: NewSoeknadWeb, options?: Headers): RestResponse<NewSoeknadWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`soeknad/saveSoeknad`, data: arg0, copyFn: __identity<NewSoeknadWeb>(), options: options });
    }

    /**
     * HTTP POST /soeknad/send
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.sendSoeknad
     */
    sendSoeknad(arg0: SendSoeknadWeb, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`soeknad/send`, data: arg0, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP PUT /soeknad/soeknadLaanUpdate
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.updateSoeknadLaan
     */
    updateSoeknadLaan(arg0: SoeknadLaanUpdateWeb, options?: Headers): RestResponse<SoeknadLaanUpdateWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`soeknad/soeknadLaanUpdate`, data: arg0, copyFn: __identity<SoeknadLaanUpdateWeb>(), options: options });
    }

    /**
     * HTTP POST /soeknad/{soeknadId}/laantaker
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.createLaantaker
     */
    createLaantaker(soeknadId: string, arg1: LaantakerWeb, options?: Headers): RestResponse<LaantakerWeb> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`soeknad/${soeknadId}/laantaker`, data: arg1, copyFn: __identity<LaantakerWeb>(), options: options });
    }

    /**
     * HTTP PUT /soeknad/{soeknadId}/laantaker
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.updateLaantaker
     */
    updateLaantaker$PUT$soeknad_soeknadId_laantaker(soeknadId: string, arg1: LaantakerWeb, options?: Headers): RestResponse<LaantakerWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`soeknad/${soeknadId}/laantaker`, data: arg1, copyFn: __identity<LaantakerWeb>(), options: options });
    }

    /**
     * HTTP PUT /soeknad/{soeknadId}/laantaker/notat
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.updateLaantakerNotat
     */
    updateLaantakerNotat(soeknadId: string, arg1: UpdatedLaantakerNotatWeb, options?: Headers): RestResponse<LaantakerWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`soeknad/${soeknadId}/laantaker/notat`, data: arg1, copyFn: __identity<LaantakerWeb>(), options: options });
    }

    /**
     * HTTP PUT /soeknad/{soeknadId}/laantaker/status
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.updateLaantakerStatus
     */
    updateLaantakerStatus(soeknadId: string, arg1: UpdatedLaantakerStatusWeb, options?: Headers): RestResponse<LaantakerWeb> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`soeknad/${soeknadId}/laantaker/status`, data: arg1, copyFn: __identity<LaantakerWeb>(), options: options });
    }

    /**
     * HTTP DELETE /soeknad/{soeknadId}/{foedselsnummer}/laantaker
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.deleteLaantaker
     */
    deleteLaantaker(soeknadId: string, foedselsnummer: string, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`soeknad/${soeknadId}/${foedselsnummer}/laantaker`, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /soeknad/{soeknadType}/laanedetaljer
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.getSoeknadLaan
     */
    getSoeknadLaan(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<SoeknadLaanContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`soeknad/${soeknadType}/laanedetaljer`, copyFn: __identity<SoeknadLaanContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /soeknad/{soeknadType}/oppsummering
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.getSoeknadOppsummering
     */
    getSoeknadOppsummering(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<SoeknadContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`soeknad/${soeknadType}/oppsummering`, copyFn: __identity<SoeknadContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /soeknad/{soeknadType}/soeknadType
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.findSoeknad
     */
    findSoeknad(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<SoeknadContainerWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`soeknad/${soeknadType}/soeknadType`, copyFn: __identity<SoeknadContainerWeb>(), options: options });
    }

    /**
     * HTTP GET /soeknad/{soeknadType}/soeknadType/findSoeknad
     * Java method: no.eika.kreditt.boliglaansoeknad.web.soeknad.SoeknadResource.findBasicSoeknad
     */
    findBasicSoeknad(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<NewSoeknadWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`soeknad/${soeknadType}/soeknadType/findSoeknad`, copyFn: __identity<NewSoeknadWeb>(), options: options });
    }

    /**
     * HTTP POST /tilbakemelding/saveTilbakemelding
     * Java method: no.eika.kreditt.boliglaansoeknad.web.tilbakemelding.TilbakemeldingResource.saveTilbakemelding
     */
    saveTilbakemelding(arg0: TilbakemeldingWeb, options?: Headers): RestResponse<boolean> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`tilbakemelding/saveTilbakemelding`, data: arg0, copyFn: __identity<boolean>(), options: options });
    }

    /**
     * HTTP GET /tilbakemelding/{soeknadId}/kvitteringInfo
     * Java method: no.eika.kreditt.boliglaansoeknad.web.tilbakemelding.TilbakemeldingResource.getKvitteringInfo
     */
    getKvitteringInfo(soeknadId: string, options?: Headers): RestResponse<KvitteringInfoWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`tilbakemelding/${soeknadId}/kvitteringInfo`, copyFn: __identity<KvitteringInfoWeb>(), options: options });
    }

    /**
     * HTTP GET /user
     * Java method: no.eika.kreditt.boliglaansoeknad.web.user.UserResource.getUser
     */
    getUser(options?: Headers): RestResponse<UserWeb> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`user`, copyFn: __identity<UserWeb>(), options: options });
    }

    /**
     * HTTP POST /vedlegg/deleteVedlegg
     * Java method: no.eika.kreditt.boliglaansoeknad.web.vedlegg.VedleggResource.deleteVedlegg
     */
    deleteVedlegg(arg0: VedleggDeleteWeb, options?: Headers): RestResponse<VedleggDeleteWeb> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`vedlegg/deleteVedlegg`, data: arg0, copyFn: __identity<VedleggDeleteWeb>(), options: options });
    }

    /**
     * HTTP POST /vedlegg/updateVedlegg
     * Java method: no.eika.kreditt.boliglaansoeknad.web.vedlegg.VedleggResource.uploadVedlegg
     */
    uploadVedlegg(options?: Headers): RestResponse<VedleggStatusWeb> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`vedlegg/updateVedlegg`, copyFn: __identity<VedleggStatusWeb>(), options: options });
    }

    /**
     * HTTP GET /vedlegg/{soeknadType}/vedlegg
     * Java method: no.eika.kreditt.boliglaansoeknad.web.vedlegg.VedleggResource.getVedlegg
     */
    getVedlegg(soeknadType: SoeknadstypeWeb, options?: Headers): RestResponse<VedleggContainerWeb | null> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`vedlegg/${soeknadType}/vedlegg`, copyFn: __identity<VedleggContainerWeb | null>(), options: options });
    }
}

export interface AdresseInfoWeb {
    andeler: BorettslagAndelWeb[];
    eiendomsVariant: EiendomVariant | null;
    matrikler: MatrikkelWeb[];
}

export interface AdresseSoekWeb {
    gatebokstav: string | null;
    gatenavn: string | null;
    gatenr: number | null;
    key: string | null;
    postnr: string;
    poststed: string | null;
}

export interface AdresseWeb {
    gatenavn: string | null;
    husnummer: string | null;
    postnr: string | null;
    poststed: string | null;
}

export interface BankWeb {
    banknavn: string;
    bankregnr: Bankregnr;
    geoOmraade: boolean;
    orgnr: Organisasjonsnummer;
    standardLoepetid: number;
    standardRaadgiverId: string;
}

export interface Bankregnr extends HarValue<string> {
    value: string;
}

export interface BarnContainerWeb {
    barn: BarnWeb[];
    dsfBarnFeilet: boolean;
    harBarn: ValgtWeb;
    laantakerFnr: string;
    soeknadId: string;
    soeknadStatus: SoeknadStatusWeb | null;
    soeknadstypeWeb: SoeknadstypeWeb;
}

export interface BarnWeb {
    betaltBarnebidrag: number;
    foedselsdato: string;
    foreldre: string[];
    harBetaltBarnebidrag: ValgtWeb;
    harMottattBarnebidrag: ValgtWeb;
    harSfoPlass: ValgtWeb;
    id: string | null;
    kilde: BarnKilde;
    kjoenn: KjoennWeb;
    mottattBarnebidrag: number;
    omsorgsansvar: Omsorgsansvar;
    sfoPlass: SFOWeb;
    status: StatusWeb;
    visSfo: boolean;
}

export interface BilContainerWeb {
    biler: BilWeb[];
    harBiler: ValgtWeb;
    soeknadId: string;
}

export interface BilUpdateWeb {
    biler: BilWeb[];
    soeknadId: string;
}

export interface BilWeb {
    drivstoff: DrivstoffWeb | null;
    eier: Eier | null;
    erLagtTilManuelt: boolean;
    erLeasing: boolean;
    id: string;
    leasingUtgift: number;
    merke: string | null;
    modell: string | null;
    registreringsnummer: string | null;
    registrertFoersteGangNorge: DateAsString | null;
    status: StatusWeb;
}

export interface BorettslagAndelWeb {
    andelsnummer: string;
    foretaksnavn: string | null;
    organisasjonsnummer: string;
}

export interface DeleteSoeknad {
    deleteReason: string | null;
    soeknadId: string;
}

export interface EgenkapitalWeb {
    annenEgenkapitalSum: number | null;
    brukBsu: boolean | null;
    bsuSum: number | null;
    harAnnenEgenkapital: ValgtWeb;
    id: string | null;
    kilde: EgenkapitalType[] | null;
    soeknadId: string;
}

export interface EiendomWeb {
    adresse: string | null;
    annetLaaneformaal: string | null;
    borettslagAndelWeb: BorettslagAndelWeb | null;
    bruk: EiendomBruk | null;
    eiendomId: string;
    eiendomsverdiWeb: EiendomsverdiWeb | null;
    etakstWeb: EtakstWeb | null;
    harEksterneHeftelserEllerKrysspant: boolean;
    id: number | null;
    kilde: EiendomskildeWeb;
    laaneformaal: Laaneformaal[];
    matrikkelWeb: MatrikkelWeb | null;
    oenskerVerdivurdering: ValgtWeb;
    overtakelsesDato: DateAsString | null;
    postnummer: string | null;
    poststed: string | null;
    type: EiendomType | null;
    uuid: string | null;
    variant: EiendomVariant | null;
}

export interface EiendomsverdiContainerWeb {
    annenBolig: boolean;
    annetLaaneformaal: string | null;
    eiendom: EiendomWeb | null;
    eksisterendeLaanebeloep: number | null;
    harBolig: ValgtWeb;
    harEtakst: ValgtWeb;
    harPantIBolig: ValgtWeb;
    laaneformaal: Laaneformaal[] | null;
    nedbetalingstid: number | null;
    soeknadId: string;
    soeknadstype: SoeknadstypeWeb;
    soektBeloep: number | null;
}

export interface EiendomsverdiParamWeb {
    borettslagAndelWeb: BorettslagAndelWeb | null;
    matrikkelWeb: MatrikkelWeb | null;
}

export interface EiendomsverdiUpdateWeb {
    annetLaaneformaal: string | null;
    eiendom: EiendomWeb | null;
    eksisterendeLaanebeloep: number | null;
    harBolig: ValgtWeb;
    harEtakst: ValgtWeb;
    harPantIBolig: ValgtWeb;
    laaneformaal: Laaneformaal[];
    nedbetalingstid: number | null;
    soeknadId: string;
    soektBeloep: number | null;
}

export interface EiendomsverdiWeb {
    fellesgjeld: number | null;
    harKryssikkerhetEllerEksterneHeftelser: boolean | null;
    id: string | null;
    markedsverdiDato: DateAsString | null;
    verdi: number | null;
}

export interface Eier {
    foedselsnummer: Foedselsnummer;
    navn: string | null;
}

export interface EngasjementWeb {
    eiendomsId: string[];
    eiendomskilde: EiendomskildeWeb;
    eiendomstype: EiendomstypeWeb;
    eksisterendeLaanebeloep: number | null;
    laantakere: LaantakerWeb[];
    laantype: LaantypeWeb | null;
    nedbetalingstid: number | null;
    nominellRente: number | null;
    restGjeld: number | null;
    terminbeloep: number | null;
}

export interface Epost extends HarValue<string> {
    value: string;
}

export interface EtakstWeb {
    aktivertDato: DateAsString | null;
    fellesgjeld: number | null;
    id: string | null;
    referansenummer: string;
    verdi: number;
}

export interface Foedselsnummer extends HarValue<string> {
    value: string;
}

export interface ForeldreWeb {
    hovedlaantaker: Foedselsnummer;
    medlaantaker: Foedselsnummer | null;
}

export interface GjeldContainerWeb {
    gjeld: GjeldWeb[];
    gjeldsregisterFeilet: boolean;
    harGjeld: ValgtWeb;
    laantaker: string;
    soeknadId: string | null;
    soeknadStatus: SoeknadStatusWeb | null;
    soeknadstype: SoeknadstypeWeb;
}

export interface GjeldDeleteWeb {
    gjeldIder: string[];
    soeknadId: string;
}

export interface GjeldWeb {
    aksjon: GjeldAksjonWeb;
    eiere: string[];
    id: string | null;
    kilde: GjeldKildeWeb | null;
    kredittramme: number | null;
    laangiver: string;
    maanedligeFellesutgifter: number | null;
    pantebeloep: number | null;
    registreringsnummer: string | null;
    registrertDato: DateAsString | null;
    restgjeld: number;
    restgjeldKunde: number | null;
    sikret: boolean;
    skalInnfris: boolean | null;
    status: StatusWeb;
    type: GjeldTypeWeb;
}

export interface HarValue<T> {
    value: T;
}

export interface HjemmesideWeb {
    value: string | null;
}

export interface InntektContainerWeb {
    harInntekt: ValgtWeb;
    inntekt: InntektWeb[];
    sblInntektFeilet: boolean;
    soeknadId: string | null;
    soeknadStatus: SoeknadStatusWeb | null;
    soeknadtype: SoeknadstypeWeb;
}

export interface InntektDeleteWeb {
    inntektIder: string[];
    soeknadId: string;
}

export interface InntektUpdateWeb {
    harInntekt: ValgtWeb;
    inntekt: InntektWeb[];
    soeknadId: string;
}

export interface InntektWeb {
    aarsinntekt: number;
    aarsinntektFraKunde: boolean;
    aarsinntektKunde: number | null;
    aarsinntektSbl: number;
    arbeidsgiver: string | null;
    arbeidssituasjonWeb: ArbeidssituasjonWeb;
    id: string | null;
    kilde: InntektKildeWeb | null;
    naavaerende: boolean;
    organisasjonsnummer: string | null;
    status: StatusWeb;
}

export interface KontaktinfoWeb {
    epost: Epost;
    fnr: Foedselsnummer;
    tlf: Telefonnummer;
}

export interface KontaktinformasjonWeb {
    annenBolig: boolean | null;
    harMedlaantaker: ValgtWeb;
    laantakere: LaantakerWeb[];
    soeknadId: string;
    visValgHarMedlaantaker: boolean;
}

export interface KvitteringInfoWeb {
    erHovedlaantaker: boolean;
    harMedlaantaker: boolean;
    navnMedlaantaker: string | null;
    soeknadId: string;
    soeknadstype: SoeknadstypeWeb;
    verdivurderingFeilet: boolean | null;
}

export interface LaantakerWeb {
    adresse: AdresseWeb | null;
    alder: number;
    epost: Epost | null;
    erHovedlaantaker: boolean;
    erKunde: boolean;
    erKundeIBank: boolean;
    etternavn: string;
    fnr: Foedselsnummer;
    fornavn: string;
    harVergemaal: boolean | null;
    inntektOgSblInnhentet: boolean;
    inntektWeb: InntektWeb[];
    kundeforholdAntallMnd: number;
    loggedIn: boolean | null;
    notat: string | null;
    postnr: Postnummer | null;
    sivilstand: SivilstandWeb | null;
    statsborgerskap: string | null;
    status: StatusWeb;
    tlf: Telefonnummer | null;
    utenlandskAdresse: UtenlandskAdresseWeb | null;
}

export interface LeieinntekterWeb {
    harSkattefrieLeieinntekter: ValgtWeb;
    harSkattepliktigeLeieinntekter: ValgtWeb;
    leiekontrakt: VedleggWeb[];
    skattefrie: number | null;
    skattepliktige: number | null;
    soeknadId: string;
}

export interface MatrikkelWeb {
    bruksnummer: string;
    festenummer: string;
    gaardsnummer: string;
    kommunenr: string;
    seksjonsnummer: string;
}

export interface NavnWeb {
    adresse: AdresseWeb | null;
    etternavn: string;
    foedselsnummer: Foedselsnummer;
    fornavn: string;
    sivilstand: SivilstandWeb;
}

export interface NewSoeknadWeb {
    eiendom: EiendomWeb | null;
    laantaker: LaantakerWeb;
    soeknadId: string | null;
    soeknadtype: SoeknadstypeWeb;
    status: SoeknadStatusWeb;
}

export interface Organisasjonsnummer extends HarValue<string> {
    value: string;
}

export interface Postnummer extends HarValue<string> {
    value: string;
}

export interface PoststedWeb {
    value: string | null;
}

export interface SamtykkeRequestWeb {
    redirectURL: string;
    soeknadstypeWeb: SoeknadstypeWeb | null;
}

export interface SamtykkeResponseWeb {
    customerUrl: string | null;
    soeknadId: string;
    soeknadStatus: SoeknadStatusWeb;
    soeknadType: SoeknadstypeWeb;
    status: SamtykkeStatusWeb | null;
    validTo: DateAsString | null;
}

export interface SendSoeknadWeb {
    kontaktinfo: KontaktinfoWeb[];
    notat: string | null;
    soeknadId: string;
    soeknadUrl: string;
    status: SoeknadStatusWeb;
}

export interface SoeknadContainerWeb {
    bil: BilWeb[];
    eiendom: EiendomWeb[];
    laantaker: LaantakerWeb[];
    soeknad: SoeknadWeb | null;
}

export interface SoeknadLaanContainerWeb {
    andelFellesgjeld: number | null;
    annetLaaneformaal: string | null;
    eiendomVerdi: number | null;
    laan: SoeknadLaanWeb;
    laaneformaal: Laaneformaal[];
    oekeLaan: ValgtWeb;
    soeknadId: string;
}

export interface SoeknadLaanUpdateWeb {
    annetLaaneformaal: string | null;
    eksisterendeLaanebeloep: number | null;
    laaneformaal: Laaneformaal[];
    nedbetalingstid: number;
    oekeLaan: ValgtWeb;
    soeknadId: string;
    soektBeloep: number | null;
}

export interface SoeknadLaanWeb {
    annetLaaneformaal: string | null;
    eksisterendeLaanebeloep: number | null;
    laaneformaal: Laaneformaal[];
    laantype: LaantypeWeb | null;
    nedbetalingstid: number | null;
    rente: number | null;
    soektBeloep: number | null;
    terminbeloep: number | null;
}

export interface SoeknadWeb {
    annenBolig: boolean | null;
    egenkapital: number | null;
    eksisterendeLaanebeloep: number | null;
    kjernekallFeilet: boolean;
    laantype: LaantypeWeb | null;
    nedbetalingstid: number | null;
    rente: number | null;
    skattefrieLeieinntekterPrMnd: number | null;
    skattepliktigeLeieinntekterPrMnd: number | null;
    soeknadId: string;
    soeknadtype: SoeknadstypeWeb | null;
    soektBeloep: number | null;
    status: SoeknadStatusWeb;
    terminbeloep: number | null;
}

export interface Telefonnummer extends HarValue<string> {
    value: string;
}

export interface TilbakemeldingWeb {
    browser: string | null;
    kommentar: string | null;
    os: string | null;
    soeknadId: string;
    soeknadstype: SoeknadstypeWeb;
    type: TilbakemeldingTypeWeb;
}

export interface UpdatedLaantakerNotatWeb {
    fnr: Foedselsnummer;
    notat: string | null;
}

export interface UpdatedLaantakerStatusWeb {
    fnr: Foedselsnummer;
    status: StatusWeb;
}

export interface UserWeb {
    loginUrl: string;
}

export interface UtenlandskAdresseWeb {
    addresselinje: string[];
    byEllerStedsnavn: string | null;
    landskode: string | null;
    postkode: string | null;
}

export interface VedleggContainerWeb {
    soeknadId: string;
    soeknadStatus: SoeknadStatusWeb | null;
    vedlegg: VedleggWeb[];
}

export interface VedleggDeleteWeb {
    dokumentNavn: string;
    soeknadId: string;
}

export interface VedleggStatusWeb {
    dokumentNavn: string;
    fileType: string;
    kategori: KategoriWeb;
    mimeType: string;
    size: number;
    status: UploadStatusWeb;
    uploaded: boolean;
}

export interface VedleggWeb {
    dokumentNavn: string;
    fileType: string;
    kategori: KategoriWeb;
    mimeType: string;
    size: number;
    uploaded: boolean;
}

export interface VerdivurderingInfoWeb {
    adresse: string;
    banknavn: string | null;
    etternavn: string | null;
    fornavn: string | null;
    mail: string | null;
    postnummer: string | null;
    poststed: string | null;
    soeknadId: string;
    tlf: string | null;
}

export type DateAsString = string;

export type RestResponse<R> = Promise<R>;

export enum ArbeidssituasjonWeb {
    IKKE_VALGT = "IKKE_VALGT",
    FAST_ANSATT = "FAST_ANSATT",
    MIDLERTIDIG_ANSATT = "MIDLERTIDIG_ANSATT",
    MOTTAKER_PENSJON_ELLER_TRYGD = "MOTTAKER_PENSJON_ELLER_TRYGD",
    SELVSTENDIG_NAERINGSDRIVENDE = "SELVSTENDIG_NAERINGSDRIVENDE",
}

export enum BarnKilde {
    DSF = "DSF",
    KUNDE = "KUNDE",
}

export enum DrivstoffWeb {
    UKJENT = "UKJENT",
    ELBIL = "ELBIL",
    BENSIN = "BENSIN",
    DIESEL = "DIESEL",
    HYBRID_BENSIN = "HYBRID_BENSIN",
    HYBRID_DIESEL = "HYBRID_DIESEL",
    PARAFIN = "PARAFIN",
    GASS = "GASS",
    HYDROGEN = "HYDROGEN",
    ANNET = "ANNET",
    BIODIESEL = "BIODIESEL",
    BIOBENSIN = "BIOBENSIN",
    LPG = "LPG",
    CNG = "CNG",
    METANOL = "METANOL",
    ETANOL = "ETANOL",
    KOMPRIMERT_LUFT = "KOMPRIMERT_LUFT",
    LNG = "LNG",
    CNG_LNG = "CNG_LNG",
}

export enum EgenkapitalType {
    LOENN = "LOENN",
    PENSJON = "PENSJON",
    SPARING = "SPARING",
    TRYGD = "TRYGD",
    ARVGAVE = "ARVGAVE",
    SALG = "SALG",
    ANNET = "ANNET",
}

export enum EiendomBruk {
    BO = "BO",
    UTLEIE = "UTLEIE",
    FRITID = "FRITID",
    ANNEN = "ANNEN",
}

export enum EiendomType {
    BUYING = "BUYING",
    SELLING = "SELLING",
}

export enum EiendomTypeWeb {
    BUYING = "BUYING",
    SELLING = "SELLING",
    CURRENT = "CURRENT",
}

export enum EiendomVariant {
    ENEBOLIG = "ENEBOLIG",
    LEILIGHET = "LEILIGHET",
    FRITID = "FRITID",
    ANNEN = "ANNEN",
    SELVEIER = "SELVEIER",
    BORETTSANDEL = "BORETTSANDEL",
    AKSJELEILIGHET = "AKSJELEILIGHET",
}

export enum EiendomskildeWeb {
    KERNE = "KERNE",
    BANQSOFT = "BANQSOFT",
    TE = "TE",
    AMBITA = "AMBITA",
    KUNDE = "KUNDE",
}

export enum EiendomstypeWeb {
    FAST_EIENDOM = "FAST_EIENDOM",
    INNSKUDDSDOKUMENT = "INNSKUDDSDOKUMENT",
    AKSJELEILIGHET = "AKSJELEILIGHET",
    BORETTSANDEL = "BORETTSANDEL",
}

export enum GjeldAksjonWeb {
    IKKE_VALGT = "IKKE_VALGT",
    BEHOLDES = "BEHOLDES",
    ERSTATTES = "ERSTATTES",
}

export enum GjeldKildeWeb {
    KERNE = "KERNE",
    BANQSOFT = "BANQSOFT",
    TE_BANK = "TE_BANK",
    TE_EBK = "TE_EBK",
    SKATTEETATEN = "SKATTEETATEN",
    AMBITA_EIENDOM_PANT = "AMBITA_EIENDOM_PANT",
    GJELDSREGISTER = "GJELDSREGISTER",
    KUNDE = "KUNDE",
    EIENDOMSVERDI = "EIENDOMSVERDI",
    BISNODE_SALGSPANT = "BISNODE_SALGSPANT",
}

export enum GjeldTypeWeb {
    IKKE_VALGT = "IKKE_VALGT",
    STUDIELAAN = "STUDIELAAN",
    BILLAAN = "BILLAAN",
    BOLIGLAAN = "BOLIGLAAN",
    NEDBETALINGSLAAN = "NEDBETALINGSLAAN",
    KREDITT = "KREDITT",
    FAKTURERINGSKORT = "FAKTURERINGSKORT",
    ANDEL_FELLESGJELD = "ANDEL_FELLESGJELD",
    ANNET = "ANNET",
}

export enum InntektKildeWeb {
    KUNDE = "KUNDE",
    SBL = "SBL",
}

export enum KategoriWeb {
    ANSETTELSESKONTRAKT = "ANSETTELSESKONTRAKT",
    LOENNSLIPPER_OG_SKATTEMELDING = "LOENNSLIPPER_OG_SKATTEMELDING",
    KJOEPEKONTRAKT = "KJOEPEKONTRAKT",
    LEIEKONTRAKT = "LEIEKONTRAKT",
    VERDIVURDERING_ELLER_TAKST = "VERDIVURDERING_ELLER_TAKST",
    ANNET = "ANNET",
}

export enum KjoennWeb {
    IKKE_VALGT = "IKKE_VALGT",
    JENTE = "JENTE",
    GUTT = "GUTT",
}

export enum Laaneformaal {
    OPPUSSING = "OPPUSSING",
    BYGGE_BOLIG = "BYGGE_BOLIG",
    KJOEPE_BIL = "KJOEPE_BIL",
    INNFRI_GJELD = "INNFRI_GJELD",
    ANNET = "ANNET",
}

export enum LaantypeWeb {
    KREDITT = "KREDITT",
    UTLAAN = "UTLAAN",
    KREDITT_UTLAAN = "KREDITT_UTLAAN",
    UKJENT = "UKJENT",
}

export enum Omsorgsansvar {
    IKKE_VALGT = "IKKE_VALGT",
    FULLT = "FULLT",
    DELT = "DELT",
    INGEN = "INGEN",
}

export enum SFOWeb {
    IKKE_VALGT = "IKKE_VALGT",
    HELTID = "HELTID",
    DELTID = "DELTID",
    INGEN = "INGEN",
}

export enum SamtykkeStatusWeb {
    UNOPENED = "UNOPENED",
    OPENED = "OPENED",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    EXPIRED = "EXPIRED",
    UNKNOWN = "UNKNOWN",
}

export enum SivilstandWeb {
    UOPPGITT = "UOPPGITT",
    UGIFT = "UGIFT",
    GIFT = "GIFT",
    ENKE_ENKEMANN = "ENKE_ENKEMANN",
    SKILT = "SKILT",
    SEPARERT = "SEPARERT",
    REGISTRERT_PARTNER = "REGISTRERT_PARTNER",
    SEPARERT_PARTNER = "SEPARERT_PARTNER",
    SKILT_PARTNER = "SKILT_PARTNER",
    GJENLEVENDE_PARTNER = "GJENLEVENDE_PARTNER",
}

export enum SoeknadStatusWeb {
    NY_SOEKNAD = "NY_SOEKNAD",
    STEG_EIENDOMSVERDI = "STEG_EIENDOMSVERDI",
    STEG_LAANEBELOEP = "STEG_LAANEBELOEP",
    STEG_SALG_BOLIG = "STEG_SALG_BOLIG",
    STEG_KONTAKTINFORMASJON = "STEG_KONTAKTINFORMASJON",
    STEG_SAMTYKKER = "STEG_SAMTYKKER",
    STEG_INNTEKT = "STEG_INNTEKT",
    STEG_LEIEINNTEKTER = "STEG_LEIEINNTEKTER",
    STEG_BILER = "STEG_BILER",
    STEG_BARN = "STEG_BARN",
    STEG_EGENKAPITAL = "STEG_EGENKAPITAL",
    STEG_GJELD = "STEG_GJELD",
    STEG_VEDLEGG = "STEG_VEDLEGG",
    STEG_OPPSUMMERING = "STEG_OPPSUMMERING",
    STEG_MEDLAANTAKER_SAMTYKKER = "STEG_MEDLAANTAKER_SAMTYKKER",
    STEG_MEDLAANTAKER_INNTEKT = "STEG_MEDLAANTAKER_INNTEKT",
    STEG_MEDLAANTAKER_BARN = "STEG_MEDLAANTAKER_BARN",
    STEG_MEDLAANTAKER_EGENKAPITAL = "STEG_MEDLAANTAKER_EGENKAPITAL",
    STEG_MEDLAANTAKER_GJELD = "STEG_MEDLAANTAKER_GJELD",
    STEG_MEDLAANTAKER_VEDLEGG = "STEG_MEDLAANTAKER_VEDLEGG",
    STEG_MEDLAANTAKER_OPPSUMMERING = "STEG_MEDLAANTAKER_OPPSUMMERING",
    KLAR_FOR_OVERFOERING_KREDITTPORTALEN = "KLAR_FOR_OVERFOERING_KREDITTPORTALEN",
    OVERFOERT_TIL_KREDITTPORTALEN = "OVERFOERT_TIL_KREDITTPORTALEN",
    FEILET = "FEILET",
    AVBRUTT = "AVBRUTT",
}

export enum SoeknadstypeWeb {
    REFINANSIERE_BOLIGLAAN = "REFINANSIERE_BOLIGLAAN",
    FINANSIERINGSBEVIS = "FINANSIERINGSBEVIS",
    NYTT_BOLIGLAAN = "NYTT_BOLIGLAAN",
    FLYTTE_BOLIGLAAN = "FLYTTE_BOLIGLAAN",
    KJOEPE_BOLIG = "KJOEPE_BOLIG",
    MEDLAANTAKER = "MEDLAANTAKER",
    MEDLAANTAKER_EGENKAPITAL = "MEDLAANTAKER_EGENKAPITAL",
    UKJENT = "UKJENT",
}

export enum StatusWeb {
    NEW = "NEW",
    NOT_CONFIRMED = "NOT_CONFIRMED",
    TO_CONFIRM = "TO_CONFIRM",
    CONFIRMED = "CONFIRMED",
    CHANGE = "CHANGE",
}

export enum TilbakemeldingTypeWeb {
    POSITIV = "POSITIV",
    NEGATIV = "NEGATIV",
}

export enum UploadStatusWeb {
    OK = "OK",
    INVALID_FILE_CONTENT = "INVALID_FILE_CONTENT",
    FILE_TOO_BIG = "FILE_TOO_BIG",
    DATABASE_ERROR = "DATABASE_ERROR",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export enum ValgtWeb {
    IKKE_VALGT = "IKKE_VALGT",
    JA = "JA",
    NEI = "NEI",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}

function __getCopyArrayFn<T>(itemCopyFn: (item: T) => T): (array: T[]) => T[] {
    return (array: T[]) => __copyArray(array, itemCopyFn);
}

function __copyArray<T>(array: T[], itemCopyFn: (item: T) => T): T[] {
    return array && array.map(item => item && itemCopyFn(item));
}

function __getCopyObjectFn<T>(itemCopyFn: (item: T) => T): (object: { [index: string]: T }) => { [index: string]: T } {
    return (object: { [index: string]: T }) => __copyObject(object, itemCopyFn);
}

function __copyObject<T>(object: { [index: string]: T }, itemCopyFn: (item: T) => T): { [index: string]: T } {
    if (!object) {
        return object;
    }
    const result: any = {};
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            const value = object[key];
            result[key] = value && itemCopyFn(value);
        }
    }
    return result;
}

function __identity<T>(): (value: T) => T {
    return value => value;
}
